export default __webpack_public_path__ + "static/media/arrow-left.ea3ebb9c.svg";